import { createSelector } from 'reselect';
import Types from 'Types';

export const domain = (state: Types.RootState) => state.glue.toast;

export const toasts = createSelector(domain, (d) => d);
